import { FC } from 'react';
import { IMechanismBreakdownMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import { DistributionDonut } from '../../../../shared/charts/DistributionDonut';
import { DistributionSlice } from '../../../../shared/charts/chart.types';
import { getPaletteColor } from './_shared/chartPalette';

interface Props {
  data: IMechanismBreakdownMetric | null;
  period?: string;
  height?: number;
}

const MECHANISM_LABELS: Record<string, string> = {
  non_contatto_sprint: 'Sprint',
  cambio_direzione: 'Cambio dir.',
  non_contatto: 'Non contatto',
  contatto: 'Contatto',
  overuse: 'Overuse',
  altro: 'Altro',
  sconosciuto: 'Sconosciuto',
};

export const MechanismBreakdownChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.items || data.items.length === 0) {
    return <ChartEmptyState />;
  }

  const slices: DistributionSlice[] = data.items.map((item, index) => ({
    id: item.mechanism,
    label: MECHANISM_LABELS[item.mechanism] ?? item.mechanism,
    value: item.count,
    percent: Math.round(item.pct),
    color: getPaletteColor(index),
  }));

  return <DistributionDonut data={slices} height={height} valueFormatter={(v) => `${v}`} />;
};
